export interface DeviceStateModel {
  clinicId: string | null;
  deviceId: string | null;
}

export const DEFAULT_STATE: DeviceStateModel = {
  clinicId: null,
  deviceId: null
};
